import { BelongsToField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import TemplateCategory from '@/data/models/domain/TemplateCategory'

@OrmModel(modelNames.TEMPLATE)
export default class Template extends BaseModel {
  @StringField()
  public id: string

  @StringField()
  public name: string

  @StringField()
  public content: string

  @StringField(null)
  public emailContent: string | null

  @StringField()
  public lastModified: string

  @StringField(null)
  public usedAt: string | null

  @StringField()
  public categoryId: string

  @BelongsToField(TemplateCategory, 'categoryId')
  public category: TemplateCategory
}
